<template lang="pug">
.code-data-container(@click="expand = !expand")
  .code-data
    .code-number
      span.material-symbols-outlined(:class="`color-${data.brand}`") percent
      span.tag(:class="`bg-${data.brand}`") {{ data.code }}

    .code-type(v-if="!history") {{ translateType(data.type) }}

    .code-discount(v-if="!history") {{ data.type === 'percent' ? percent(data.percent) : money(data.value) }}

    .code-quantity(v-if="!history")
      span(v-if="data.quantity != null") {{ data.remaining }} / {{ data.quantity }}
      span(v-else) Ilimitado

    .code-phone(v-if="!history") {{ data.phone || '—' }}

    .code-status(v-if="!history")
      .tag(:style="styleActive") {{ data.active ? 'Activo' : 'Inactivo' }}

    .code-transaction(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}

    .code-date(v-if="history") {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

  transition(name="slide-fade")
    shForm.list-code(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-code(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'Code',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory },

  props: {
    data: Object,
    index: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    translateType (type) {
      const map = {
        percent: 'Porcentaje',
        value: 'Valor'
      }
      return map[type] || type
    }
  },

  computed: {
    styleActive () {
      return this.data.active
        ? 'background: #5cb85c; color: #fff'
        : 'background: #e9e9e7; color: #616161'
    }
  }
}
</script>

<style lang="stylus">
.code-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em

.code-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis 100%
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em

.code-number
  display flex
  align-items center
  gap .5em

.list-code
  flex-basis 100%
  flex-shrink 0
  width 100%

@media (pointer: fine)
  .code-data
    column-gap 0
    row-gap 1em

  .code-number
    width 14em
  .code-type
    width 8em
  .code-discount
    width 8em
  .code-quantity
    width 8em
  .code-phone
    width 10em
  .code-status
    width 7em
  .code-transaction
    width 8em
  .code-date
    width 10em
</style>



// WEBPACK FOOTER //
// src/components/pages/code/Code.vue